export enum ExamDoneReason {
  CandidateSubmitted = "CandidateSubmitted",
  AdminsClosed = "AdminsClosed",
}
